import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';
import i18n from "./i18n";
import { LanguageProvider } from "./context/LanguageContext";
import installAuthFetchInterceptor from "./utils/installAuthFetchInterceptor";
import reportWebVitals from './reportWebVitals';

const pickEnvVar = (...keys) =>
  keys
    .map((key) => (process.env[key] || '').trim())
    .filter((value) => value.length > 0)[0];

const sentryDsn = pickEnvVar('REACT_APP_SENTRY_DSN', 'VITE_SENTRY_DSN');

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    sendDefaultPii: true,
    environment: process.env.NODE_ENV ?? 'development',
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    tracesSampleRate: 1.0,
  });
} else if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line no-console
  console.warn('Sentry DSN is not configured; Sentry will remain disabled.');
}

const RootErrorFallback = () => (
  <div
    role="alert"
    style={{
      padding: '2rem',
      maxWidth: '420px',
      margin: '0 auto',
      textAlign: 'center',
    }}
  >
    <p>{i18n.t("app.errorBoundary.message")}</p>
    <button type="button" onClick={() => window.location.reload()}>
      {i18n.t("app.errorBoundary.reload")}
    </button>
  </div>
);

// Install global fetch interceptor before the app renders
installAuthFetchInterceptor();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<RootErrorFallback />}>
      <LanguageProvider>
        <App />
      </LanguageProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
